import { User } from '../../interfaces/api/user';
import { getUser, getUsers } from '../../api/users';

export async function fetchUsers(): Promise<User[]> {
	try {
		return await getUsers();
	} catch (error) {
		throw error;
	}
}

export async function fetchUser(): Promise<User> {
	try {
		return await getUser();
	} catch (error) {
		throw error;
	}
}
